import axios from '../api/axios';

export async function getAdmins() {
  const res = await axios.get(`/admins`);

  return res.data;
}

export async function getAdmin(adminId) {
  const res = await axios.get(`/admins/${adminId}`);

  return res.data;
}

export async function createAdmin(body) {
  const res = await axios.post(`/admins`, JSON.stringify(body), {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
}

export async function updateAdmin(adminId, body) {
  const res = await axios.patch(`/admins/${adminId}`, JSON.stringify(body), {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
}

export async function deleteAdmin(adminId) {
  const res = await axios.delete(`/admins/${adminId}`);

  return res.data;
}
